import React from 'react';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';

export function DhcdList({items}) {
    const router = useRouter();
    const {locale} = router;

    const handleDownload = url => {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '');
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
    return (
        <ul className="dhcd-list">
            {items.map((it, idx) => (
                <li className="dhcd-item" key={it.id ?? idx}>
                    <div className="item-left">
                        <div className="item-title">
                            <a
                                href={it.link || it.file}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="item-title-link">
                                {it.title}
                            </a>
                        </div>

                        {it.date && <div className="item-date">{it.date}</div>}
                    </div>

                    {it.file && (
                        <button
                            style={{border: 'none', background: 'none', padding: 0, fontWeight: 400}}
                            type="button"
                            className="item-download"
                            onClick={() => handleDownload(it.file)}>
                            <span className="download-text">
                                {getLocaleContent(locale, 'page.shareholder-relations.download')}
                            </span>
                            <img src="/bw_image/ic_pdf_download.svg" alt="Download" className="download-icon" />
                        </button>
                    )}
                </li>
            ))}

            {items.length === 0 && (
                <li className="dhcd-item empty">{getLocaleContent(locale, 'page.shareholder-relations.no_news')}</li>
            )}
        </ul>
    );
}
